<template>
	<div class="submit">
		<h3>我的反馈</h3>
		<el-button class='searchBox' type="primary" size="small" icon="el-icon-sort" @click='centerDialogVisible =true'>意见反馈</el-button>
		<div class="table">
			<el-table :data="tableData4" style="width: 100%" height='calc(100vh - 250px)'>
				<el-table-column prop="wt.id" label="ID" align='center'></el-table-column>
				<el-table-column label="问题描述" >
					<template slot-scope="scope">
						<p>{{scope.row.list[0].replyText}}</p>
						<span  v-for="item in scope.row.list[0].listArr">
							<img class="img" :src="item.url" v-if='item.status == 1' @click="fileArrurl=scope.row.list[0].listArr;centerDialogVisible3=true">
							<a target="_blank" v-else :href="item.url" download="下载" class="el-icon-download" :title="item.url">下载</a>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="提交人" align='center'>
					<template slot-scope="scope">
						<span>{{subName}}</span>
					</template>
				</el-table-column>
				<el-table-column label="提交时间" align='center'>
					<template slot-scope="scope">
						<span>{{ setTime(scope.row.list[0].createAt)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" align='center'>
					<template slot-scope="scope">
						<span class="yellow">{{status[scope.row.wt.status - 1]}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align='center'>
					<template slot-scope="scope">
						<el-button v-if='scope.row.wt.status >= 3' type="text" disabled>关闭工单</el-button>
						<el-button v-else type="text" @click='centerDialogVisible1=true;deleteId=scope.row.wt.id'>关闭工单</el-button>
						<router-link class='blue' :to="{name:'submitDetails',params:{data:scope.row}}">查看详情</router-link>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye">
			<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]"
			 :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="allpage">
			</el-pagination>
		</div>
		<!-- 弹窗 -->
		<el-dialog title="提交工单" :visible.sync="centerDialogVisible" center>
			<el-form label-width="110px" :model="formLabelAlign" ref="numberValidateForm">
				<el-form-item label="问题描述" prop="name" :rules="[
				  { required: true, message: '问题描述不能为空'}
				]">
					<el-input type='textarea' v-model="formLabelAlign.name" placeholder='请输入你的阶段性工作目标'></el-input>
				</el-form-item>
				<el-form-item label="联系人手机号" prop="region" :rules="[
				  { required: true, message: '手机号不能为空'},
				  { type: 'number', message: '手机号必须为数字值'}
				]">
					<el-input v-model.number="formLabelAlign.region"></el-input>
				</el-form-item>
				<el-form-item label="上传附件">
					<el-upload class="upload-demo"
					action="aaa"
					:on-preview="handlePreview"
					:on-remove="handleRemove"
					:before-remove="beforeRemove"
					multiple
					:limit="5"
					:on-exceed="handleExceed"
					:file-list="fileList"
					:before-upload="beforeAvatarUpload"
					:http-request="requestFile"
					 >
						<el-button size="small" type="primary" :loading="uploadBtn">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">可上传5个附件，每个附件大小不得超过8M</div>
					</el-upload>
				</el-form-item>
			</el-form>
			<el-button class='btn' type="primary" @click="submitForm('numberValidateForm')">提交</el-button>
		</el-dialog>
		<!-- 删除工单 -->
		<el-dialog title="提示" :visible.sync="centerDialogVisible1" width="30%" center>
			<span>确定删除工单？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible1 = false">取 消</el-button>
				<el-button type="primary" @click="deleteFun">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="附件查看" :visible.sync="centerDialogVisible3" center>
			<el-carousel :interval="4000" type="card" height="200px">
				<el-carousel-item v-for="(item,index) in fileArrurl" :key="index" v-if="item.status == 1">
				  <img style="width: 100%;" :src="item.url">
				</el-carousel-item>
			</el-carousel>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'
	import { createGd,createGdList,uploadPost,createGdClose } from '@/axios/api.js'
	import common from '@/assets/common.js'
	export default {
		data() {
			return {
				searchText: '',
				tableData: [],
				tableData4: [],
				centerDialogVisible: false,
				centerDialogVisible1: false,
				centerDialogVisible2: false,
				centerDialogVisible3: false,
				formLabelAlign: {
					name: '',
					region: ''
				},
				fileList: [],
				fileUrl:[],
				uploadBtn:false,
				subName:JSON.parse(window.localStorage.getItem("token")).data.obj2.name,
				fileArrurl:[],
				allpage:0,//数据总数
				eachPage:10,//每页
				indexPage:1,//当前页
				deleteId:'',
				status:['已提交','已处理待反馈','已关闭-用户','已关闭-系统']
			};
		},
		methods: {
			setTime(str) {
				return common.time(str)
			},
			handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.tableData4 = this.tableData.slice(0, this.eachPage);
				console.log()
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = val;
				this.tableData4 = this.tableData.slice(this.eachPage * (this.indexPage - 1), this.eachPage * this.indexPage);
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.creatFun()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			//上传
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			beforeAvatarUpload(file) {
				const isLt8M = file.size / 1024 / 1024 < 8;
				if (!isLt8M) {
					this.$message.error('上传头像图片大小不能超过 8MB!');
				}
				return isLt8M;
			},
			creatFun(){
				var data={
					billingId:'',
					mobileno:this.formLabelAlign.region,
					replyText:this.formLabelAlign.name,
					attachments:JSON.stringify(this.fileUrl)
				}
				createGd(data)
				.then(res => {
					console.log(res)
					if(res.data.code == 0){
						this.$message({
						  message: '恭喜您，提交成功！',
						  type: 'success'
						});
						this.centerDialogVisible=false;
						this.getData();
						this.$refs['numberValidateForm'].resetFields();
					}
				})
				.catch( err => {
					console.log(err)
				})
			},
			getData(){
				var data={
					start:0,
					count:100
				}
				createGdList(data)
				.then(res => {
					console.log(res)
					var reg = /(.*)\.(jpg|gif|bmp|png)$/
					this.tableData=res.data.obj;
					this.allpage=this.tableData.length;
					this.handleSizeChange(this.eachPage);
					this.tableData.forEach(item => {
						if(item.list[0].attachments == '' || item.list[0].attachments == undefined) return
						item.list[0].attachments1=JSON.parse(item.list[0].attachments);
						var listArr=[];
						item.list[0].attachments1.forEach((item1,index) => {
							if(reg.test(item1)){
								listArr.push({url:item1,status:1})
							}else{
								listArr.push({url:item1,status:0})
							}
						})
						item.list[0].listArr=listArr
					})
				})
				.catch( err => {
					console.log(err)
				})
			},
			requestFile(param) {
				this.uploadBtn=true;
				var fileObj = param.file
				let config = {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				};
				var form = new FormData() // FormData 对象
				var token = JSON.parse(window.localStorage.getItem("token")).data.obj.token
				form.append('file', fileObj) // 文件对象
				form.append('token', token) // 文件对象
				axios.post(SEVERS + 'rescue_sale/sale/upload', form, config)
					.then(res => {
						if (res.data.code == 0) {
							this.fileUrl.push(res.data.obj);
							this.uploadBtn=false
						}
					})
					.catch(err => {
						console.log(err)
					})
			},
			deleteFun(){
				var data={
					id:this.deleteId
				}
				createGdClose(data)
				.then(res => {
					console.log(res)
					if(res.data.code == 0){
						this.$message({
						  message: '工单已关闭！',
						  type: 'success'
						});
						this.centerDialogVisible1=false;
						this.getData()
					}else{
						this.$message.error(res.data.msg)
					}
				})
				.catch(err => {
					console.log(err)
				})
			}
		},
		mounted() {
			this.getData()
		}
	}
</script>
<style>
	.has-gutter th {
		background-color: #f5f7fb;
	}
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>
<style scoped="scoped">
	h3 {
		color: #333;
		font-weight: normal;
		margin-bottom: 20px;
		margin-top: 20px;
	}

	.submit {
		position: relative;
	}

	.searchBox {
		position: absolute;
		top: 0;
		right: 0;
	}

	.input {
		width: 400px;
	}

	.blue {
		color: #00ABFA;
		cursor: pointer;
	}

	.fenye {
		margin-top: 20px;
		overflow: hidden;
	}

	.fenye .pagination {
		float: right;
	}

	.btn {
		width: 200px;
		display: block;
		margin: 0 auto;
		cursor: pointer;
	}
	.img{width: 40px;margin-right: 5px;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/views/shop/submit.vue